import { render, staticRenderFns } from "./monthworkdetail.vue?vue&type=template&id=5c58b28a"
import script from "./monthworkdetail.vue?vue&type=script&lang=js"
export * from "./monthworkdetail.vue?vue&type=script&lang=js"
import style0 from "./monthworkdetail.vue?vue&type=style&index=0&id=5c58b28a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports